import { uiActionsFactory } from '../../restux/ui/restuxUiActions.factory'

export const bottomPanelDocumentTemplatesActions = uiActionsFactory({
  resourceName: 'documentTemplate',
  identifier: 'bottomPanel',
}).actions
